import { HttpClient } from '@angular/common/http';
import { INgxLoadingConfig, ngxLoadingAnimationTypes } from 'ngx-loading';
import { TranslateModuleConfig, TranslateLoader } from '@ngx-translate/core';

import { MultiTranslateService } from '@service/multi-translate.service';

export function translateFactory(http: HttpClient): MultiTranslateService {
  return new MultiTranslateService(http);
}

export const TRANSLATE_CONFIG: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: translateFactory,
    deps: [HttpClient]
  }
};

export const LOADING_CONFIG: INgxLoadingConfig = {
  animationType: ngxLoadingAnimationTypes.circle,
  backdropBackgroundColour: 'rgba(0,0,0,0.1)',
  backdropBorderRadius: '3px',
  primaryColour: '#003781',
  secondaryColour: '#007ab3',
  tertiaryColour: '#ffffff'
};
